
/*eslint-disable*/
import React from "react";
// reactstrap components
import {Col, Container, Nav, NavItem, NavLink, Row} from "reactstrap";

class Login extends React.Component {
  render() {
    return (
      <>
        <footer className="py-5" id="footer-main">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className="copyright text-center text-xl-left text-muted">
                  © {new Date().getFullYear()}{" "}
                  <a
                      className="font-weight-bold ml-1"
                      href="https://sekim-international.com/"
                      target="_blank"
                  >
                    Sekim International
                  </a>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                  <NavItem>
                    <NavLink
                        href="https://xaregrowth.com"
                      target="_blank"
                    >
                        XareGrowth
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        onClick={(event) => {
                            event.preventDefault();
                            window.location.href = getNewUiUrl() + "/about-us";
                        }}
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        href=""
                        target="_blank"
                    >
                      Blog
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        href=""
                        target="_blank"
                    >
                      License
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default Login;
